import React from 'react';
import { InboxIcon, SmartphoneIcon, BellIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';

/* 2026-09-08 (compliance, Kevin): this section previously sold review
   solicitation. It read "Asked for after every job / The request goes out
   automatically", plus "You hear about a bad one first / An unhappy customer
   pings you before your next customer reads it", which is review gating.
   Yelp flagged Viridia for review solicitation, and gating is an FTC issue
   independent of Yelp. All of it is removed.

   The slot is now the unified inbox, which is a real listed deliverable
   (see packageIncludes in data/site.ts) and was not shown anywhere else on
   the page. The file and the exported name are still Reputation only so the
   live import in pages/HowItWorks.tsx did not have to change during an
   urgent edit; rename both in the next planned pass.

   Do not reinstate review copy here or anywhere else on the site. */

const points = [{
  Icon: InboxIcon,
  title: 'One inbox, not five apps',
  body: 'Yelp, Google, Facebook, your website and your business line all feed the same inbox, so a lead cannot sit unread in a tab nobody opened.'
}, {
  Icon: SmartphoneIcon,
  title: 'Answer from the truck',
  body: 'Reply from the mobile app the way you would text anyone. The customer sees your business number, never your personal one.'
}, {
  Icon: BellIcon,
  title: 'You hear about it while it matters',
  body: 'A message that lands at 7pm pings you at 7pm. Nobody finds it at nine the next morning, after the job went to whoever answered.'
}];
export function Reputation() {
  return <section className="relative isolate overflow-hidden border-b border-[#1a1a1a] bg-[#0c0c0c]" data-id="element-655" data-mp="3t8a4rc873ljt">
      <Bloom size="lg" className="left-1/2 top-[-18rem] -translate-x-1/2" data-id="element-656" data-mp="35ipiajcu265s" />
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-657" data-mp="30k5vyhubuscw">
        <SectionLabel data-id="element-658" data-mp="30jw74xl0qr8s">One inbox</SectionLabel>
        <h2 className="mt-8 max-w-3xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-5xl" data-id="element-659" data-mp="3q8thh3oxk1bs">
          Every message in one place.
        </h2>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-neutral-400" data-id="element-660" data-mp="3u7shqazpv9ww">
          Calls, texts, Yelp messages, Google and Facebook, all landing in the same
          place instead of five apps you check at night.
        </p>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-661" data-mp="379xotwspzv02">
          {points.map(({
          Icon,
          title,
          body
        }) => <article key={title} className="rounded-2xl border border-[#1c1c1c] bg-[#0d0d0d] p-8 transition-colors hover:border-emerald-500/40" data-id="element-662" data-mp="3bc2e6jc4y5gw">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-500/10" data-id="element-663" data-mp="3l9gw6ndpj2bb">
                <Icon className="h-5 w-5 text-emerald-500" aria-hidden="true" data-id="element-664" data-mp="vitql9dxhe5i" />
              </span>
              <h3 className="mt-6 text-lg font-semibold text-white" data-id="element-665" data-mp="10hwwsx5n9qf2">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400" data-id="element-666" data-mp="2l1juiem1bdz7">{body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}